import { GET_PAST_ASSESSMENT_SUMMARY } from './constants';
import { AssessmentSummaryResponse } from './fetchAssessmentSummary';
import fetchWithRefresh from './fetchWithRefresh';

export default (saId: string): Promise<AssessmentSummaryResponse> => {
    return fetchWithRefresh(GET_PAST_ASSESSMENT_SUMMARY(saId)).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('GET_PAST_ASSESSMENT_SUMMARY failed');
        }
    });
};
